import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';

import { isRequired, validateEndDate } from '../../../../utils/validators';

import FormItem from '../../../common/forms/FormItem';
import FormFooter from '../../../common/forms/FormFooter';
import DatePicker from '../../../common/forms/input/DatePicker';
import SupplierSelect from '../../../common/forms/select/SupplierSelect';

const validateDate = (value, allValues) =>
  validateEndDate(value, allValues.fromDateString);

export const ItinerarySupplierFoodReportForm = ({
  handleSubmit,
  loading,
  onDownloadExcel,
}) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup row>
      <FormItem label="Proveedor">
        <Field name="supplierId" component={SupplierSelect} isClearable />
      </FormItem>
    </FormGroup>

    <FormGroup row>
      <FormItem label="Desde" required>
        <Field
          name="fromDateString"
          component={DatePicker}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>

    <FormGroup row>
      <FormItem label="Hasta" required>
        <Field
          name="toDateString"
          component={DatePicker}
          validate={[isRequired, validateDate]}
        />
      </FormItem>
    </FormGroup>

    <FormFooter saveButtonText="Buscar" saveButtonIcon="fa fa-search">
      {onDownloadExcel && (
        <Button
          type="button"
          color="success"
          onClick={handleSubmit(onDownloadExcel)}
          disabled={loading}
        >
          {loading ? (
            <>
              <i className="fa fa-spinner fa-spin" /> Descargando...
            </>
          ) : (
            <>
              <i className="fa fa-file-excel-o" /> Descargar Excel
            </>
          )}
        </Button>
      )}
    </FormFooter>
  </Form>
);

ItinerarySupplierFoodReportForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  onDownloadExcel: PropTypes.func,
};

ItinerarySupplierFoodReportForm.defaultProps = {
  loading: false,
  onDownloadExcel: null,
};

const formComponent = reduxForm({
  form: 'ItinerarySupplierFoodReportForm',
})(ItinerarySupplierFoodReportForm);

export default formComponent;
